import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";

import ScrollToTop from "./components/helpers/scrolltoTop";
import ScandinaviaFoodGroup from "./pages/landing/landing";
import FullScreenLoader from "./components/helpers/fullScreenLoader";
import { AuthProvider } from "./context/authContext";
import ProtectedRoute from "./components/helpers/protectedRoute";

// Route-level code splitting: keeps the landing page's initial bundle
// small since these are only needed once a visitor navigates further.
const ProductCatalog = lazy(() => import("./pages/product/productCatalog"));
const SignUpPage = lazy(() => import("./pages/authentication/signupPage"));
const Profile = lazy(() => import("./pages/authentication/profile"));
const LoginPage = lazy(() => import("./pages/authentication/loginPage"));
const NotFoundPage = lazy(() => import("./pages/404/notfoundPage"));
const PrivacyPolicy = lazy(() => import("./pages/policy/privacy"));
const CookiesPolicy = lazy(() => import("./pages/policy/cookies"));
const MainManagementPage = lazy(
  () => import("./pages/management/mainManagementPage"),
);

function App() {
  return (
    <div>
      <ScrollToTop />
      <AuthProvider>
        <Suspense fallback={<FullScreenLoader />}>
          <Routes>
            {/*-------------Landing-------------*/}
            <Route path="/" element={<ScandinaviaFoodGroup />} />
            <Route path="/products" element={<ProductCatalog />} />
            <Route
              path="/management"
              element={
                <ProtectedRoute>
                  <MainManagementPage />
                </ProtectedRoute>
              }
            />
            {/*-------------Landing-------------*/}

            {/*-------------Authentication-------------*/}
            <Route path="/register" element={<SignUpPage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/login" element={<LoginPage />} />
            {/*-------------Authentication-------------*/}

            {/*-------------Policy-------------*/}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookies-policy" element={<CookiesPolicy />} />
            {/*-------------Policy-------------*/}

            {/* 404 Route */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </div>
  );
}

export default App;
